module.exports = __webpack_public_path__ + "img/MyChoice2201_AAC.83f4ed3a.jpg";